import { createSlice } from "@reduxjs/toolkit";
import type { SystemField } from "../../models/systemFields";
import { getSystemFields } from "../thunks/systemFieldsThunks";

export interface SystemFieldsState {
  fieldsLoading: boolean;
  fieldsError: string | null;
  systemFields: SystemField[];
}

const initialState: SystemFieldsState = {
  fieldsLoading: false,
  fieldsError: null,
  systemFields: [],
};

const systemFieldsSlice = createSlice({
  name: "systemFields",
  initialState,
  reducers: {
    clearSystemFieldsError: (state) => {
      state.fieldsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSystemFields.pending, (state) => {
        state.fieldsLoading = true;
        state.fieldsError = null;
      })
      .addCase(getSystemFields.fulfilled, (state, action) => {
        state.fieldsLoading = false;
        state.systemFields = action.payload.systemFields;
      })
      .addCase(getSystemFields.rejected, (state, action) => {
        state.fieldsLoading = false;
        state.fieldsError =
          action.payload || action.error.message || "Failed to fetch system fields";
      });
  },
});

export const { clearSystemFieldsError } = systemFieldsSlice.actions;
export default systemFieldsSlice.reducer;
